module.exports = __webpack_public_path__ + "static/ravel-share-img-1ed895bf86f76a4d179b45b3ef31c4f9.jpg";